import { NoteOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  Tooltip,
  type TooltipProps,
  Typography,
} from '@carboncopyco/ui';
import { type ReactNode, useRef } from 'react';

type ErrorIndicationProps = {
  label: ReactNode;
  delay?: TooltipProps['delay'];
};

export const ErrorIndication = ({
  label,
  delay = [300, undefined],
}: ErrorIndicationProps) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <>
      <div ref={ref}>
        <NoteOutlineIcon
          color={ColorHex.danger300}
          size={20}
        />
      </div>
      <Tooltip
        anchorRef={ref}
        placement="top"
        noArrow
        delay={delay}
      >
        <div className="p-3">
          <Typography
            fontSize="text-ds-200"
            lineHeight="leading-ds-200"
            color="text-ds-natural"
            fontWeight="font-ds-normal"
            letterSpacing="tracking-ds-tight"
            label={label}
          />
        </div>
      </Tooltip>
    </>
  );
};

ErrorIndication.displayName = 'ErrorIndication';
